// extracted by css-extract-rspack-plugin
export default {"form":"form-Ck4d4Y","customRange":"customRange-_5SuLH","dateInputs":"dateInputs-O0Cisd","dateInput":"dateInput-YD8kpr"};